import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {List, ListItem, Flex, Heading, Text, Icon} from '@spothero/ui';
import {rightColumnItemStyleProps} from 'pages/parking-pass/styles';
import {
    PROPTYPE_RESERVATION_AMENITY,
    PROPTYPE_RESERVATION_MONTHLY_IN_OUT_DETAIL,
} from '@/proptypes/reservation-prop-types';
import AmenityUtils from '@spothero/utils/amenity';
import ReservationUtils from 'utils/reservation-utils';

const IN_OUT_SLUG = 'in_out';

const Amenities = ({amenities, reservationType, monthlyInOutDetail}) => {
    const amenitiesWithIcons = useMemo(() => {
        if (!amenities || !amenities?.length) {
            return [];
        }

        const formattedAmenities = amenities.map(amenity => ({
            ...amenity,
            icon: AmenityUtils.getIcon(amenity.slug),
        }));

        if (
            reservationType === ReservationUtils.RESERVATION_TYPES.MONTHLY &&
            ReservationUtils.IN_OUT_MAPPING[monthlyInOutDetail.inOutAllowed]
        ) {
            formattedAmenities.push({
                name:
                    ReservationUtils.IN_OUT_MAPPING[
                        monthlyInOutDetail.inOutAllowed
                    ],
                slug: 'monthly_in_out',
                icon: AmenityUtils.getIcon(IN_OUT_SLUG),
            });
        }

        return formattedAmenities;
    }, [amenities, reservationType, monthlyInOutDetail]);

    if (!amenities || !amenities?.length) {
        return null;
    }

    return (
        <Flex {...rightColumnItemStyleProps} alignItems="flex-start">
            <Heading as="h3" fontSize="base" marginBottom={2}>
                Amenities
            </Heading>
            <List>
                {amenitiesWithIcons.map(amenity => (
                    <ListItem
                        marginBottom={2.5}
                        _last={{marginBottom: 0}}
                        key={amenity.slug}
                    >
                        <Flex alignItems="center">
                            <Icon
                                width="1.125rem"
                                height="auto"
                                marginRight={3}
                                as={amenity.icon}
                            />
                            <Text lineHeight="1.4">{amenity.name}</Text>
                        </Flex>
                    </ListItem>
                ))}
            </List>
        </Flex>
    );
};

Amenities.propTypes = {
    amenities: PropTypes.arrayOf(PROPTYPE_RESERVATION_AMENITY),
    monthlyInOutDetail: PROPTYPE_RESERVATION_MONTHLY_IN_OUT_DETAIL,
    reservationType: PropTypes.oneOf(
        Object.values(ReservationUtils.RESERVATION_TYPES)
    ),
};

export default Amenities;
